module.exports = __webpack_public_path__ + "img/IMG-4840.ac5a67ab.jpg";